import React from "react";
import { ReferenceInput, SelectInput } from "react-admin";

export const OperationalTerminalInput = ({ helperText, ...props }) => (
	<ReferenceInput
		source="operational_terminal_id"
		reference="terminal"
		allowEmpty
		{...props}
	>
		<SelectInput helperText={helperText} />
	</ReferenceInput>
);
